import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@learningblocks/exp-constants/lib/Images/ps_powerbutton_icon.svg';
import {Button, Image} from '@learningblocks/storybook-components';

import './style.scss';

export function PowerButton(props) {
  const className = props.disabled
    ? 'ps_powerButton-disabled'
    : 'ps_powerButton';

  return (
    <div className={props.className}>
      <Button className={className} onClick={props.onClick}>
        <Image src={Icon} alt='power button icon' />
      </Button>
    </div>
  );
}

PowerButton.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * callback function to trigger on click
   */
  onClick: PropTypes.func,
};

PowerButton.defaultProps = {
  disabled: false,
};
